import * as constants from '../constants';

const INITIAL_STATE = {
    tags: [],
    loading: false,
    error: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;
        case constants.SURVEY_TAGS_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null});
        case constants.SURVEY_TAGS_SUCCESS:
            return Object.assign({}, state, {loading: false, tags: action.payload.tags, error: null});
        case constants.SURVEY_TAGS_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});
    }
    return state;
}

export const surveyTagsSelector = (state) => state.surveyTags.tags;
export const surveyTagsLoadingSelector = (state) => state.surveyTags.loading;
